import { useState, useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

export default function OurStory() {
  const [index, setIndex] = useState(0);
  const [touchStartX, setTouchStartX] = useState(null);
  const [showSwipeHint, setShowSwipeHint] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    if (!isMobile) return;
    setShowSwipeHint(true);
    const timer = setTimeout(() => setShowSwipeHint(false), 2500);
    return () => clearTimeout(timer);
  }, [isMobile]);

  const handleTouchStart = (e) => {
    setTouchStartX(e.touches[0].clientX);
  };

  const handleTouchEnd = (e) => {
    if (touchStartX === null) return;
    const delta = touchStartX - e.changedTouches[0].clientX;
    if (delta > 50) setIndex(1);
    else if (delta < -50) setIndex(0);
    setTouchStartX(null);
  };

  return (
    <div className="our-story-slider" style={{ position: "relative" }}>
      {showSwipeHint && isMobile && (
        <div
          onClick={() => setShowSwipeHint(false)}
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.65)",
            animation: "swipeHintFade 2.5s ease forwards",
            pointerEvents: "auto",
          }}
        >
          <style>{`
            @keyframes swipeHintFade {
              0%   { opacity: 0; }
              20%  { opacity: 1; }
              80%  { opacity: 1; }
              100% { opacity: 0; }
            }
            @keyframes swipeArrow {
              0%, 100% { transform: translateX(0); }
              50%       { transform: translateX(-12px); }
            }
          `}</style>
          <span style={{ color: "white", fontSize: "2rem", marginTop: "0.5rem" }}>Swipe!</span>
          <span style={{ fontSize: "3rem", color: "white", animation: "swipeArrow 1s ease-in-out infinite" }}>&#8594;</span>
        </div>
      )}
      <div
        className="our-story-track"
        style={{ transform: `translateX(-${index * 50}%)` }}
        onTouchStart={isMobile ? handleTouchStart : undefined}
        onTouchEnd={isMobile ? handleTouchEnd : undefined}
      >
        <div className="our-story-slide">
          <div className="our-story-img-panels">
            <div className="our-story-img-panel">
              <img
                src="img/our-story/dating_1.jpg"
                alt="Adam and Tori going for a walk to Tim Hortons"
                style={{ width: "100%" }}
              />
              <img
                src="img/our-story/dating_2.jpg"
                alt="Adam and Tori in love"
                style={{ width: "100%" }}
              />
            </div>
            <div className="our-story-img-panel">
              <img
                src="img/our-story/dating_3.jpg"
                alt="Adam and Tori hiking in the woods near Kimball Lake"
                style={{ width: "100%" }}
              />
              <img
                src="img/our-story/dating_4.jpg"
                alt="Adam and Tori at the Calgary Comicon"
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                margin: "1rem",
                width: "75%",
                backgroundColor: "white",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                padding: "1rem",
                borderRadius: "5px",
              }}
            >
              <div
                style={{
                  fontFamily: "Pinyon Script, cursive",
                  fontSize: "2rem",
                  textAlign: "center",
                }}
              >
                Day One
              </div>
              <div>
                Our story began on November 24th, 2023, at the Longbranch Bar in
                Saskatoon, SK. We both attended the Malpractice Mixer, a
                pub-crawl fundraiser put on by the Health Sciences Student
                Association and the Law Students' Association. Adam was not a
                part of either of these associations, but he did have some
                friends in law. He snuck in under the guise of a Law student.
                Tori didn't buy it for a second. She walked up to Adam and said,
                "You don't look like you're in law." Taken aback, Adam asked,
                “Oh yeah? What do I look like I'm in?” “Computer Science.” He
                was in love.
              </div>
            </div>
            {!isMobile && index === 0 && (
              <button
                type="button"
                className="nav-button-right"
                onClick={() => setIndex(1)}
                aria-label="To engagement story"
              >
                {"\u203A"}
              </button>
            )}
          </div>
        </div>
        <div className="our-story-slide">
          <div className="our-story-img-panels">
            <div className="our-story-img-panel">
              <img
                src="img/our-story/engagement_1.jpg"
                alt="Adam and Tori walking along the beach at Cleveland Beach, NS just before Adam proposed to Tori"
                style={{ width: "100%" }}
              />
              <img
                src="img/our-story/engagement_2.jpg"
                alt="Far shot of Adam proposing to Tori"
                style={{ width: "100%" }}
              />
            </div>
            <div className="our-story-img-panel">
              <img
                src="img/our-story/engagement_3.jpg"
                alt="Close up of Tori's engagement ring."
                style={{ width: "100%" }}
              />
              <img
                src="img/our-story/engagement_4.jpg"
                alt="Adam and Tori embracing after the proposal."
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {!isMobile && index === 1 && (
              <button
                type="button"
                className="nav-button-left"
                onClick={() => setIndex(0)}
                aria-label="To meeting story"
              >
                {"\u2039"}
              </button>
            )}
            <div
              style={{
                margin: "1rem",
                width: "75%",
                backgroundColor: "white",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
                padding: "1rem",
                borderRadius: "5px",
              }}
            >
              <div
                style={{
                  fontFamily: "Pinyon Script, cursive",
                  fontSize: "2rem",
                  textAlign: "center",
                }}
              >
                The Engagement
              </div>
              <div>
                On August 11th, 2025, we woke up at 7 am, much earlier than Tori
                would have liked on her last day of vacaction in the Maritimes.
                Adam wanted to go check out an area near Peggy's Cove. We left
                at around 7:30. Tori demanded sushi on the way (reparations for
                having to wake up at such an ungodly hour). Once we had our fill
                of sushi, we continued on our journey, and were soon met by a
                pair of garbage trucks blocking our way. Tori noticed that Adam
                was getting more and more anxious, to which Adam retorted that
                he was "Not a very patient person". Anyone who knows Adam at all
                will know that this is not the case. Once we had evaded the
                garbage truck goliaths, we finally reached our destination:
                Cleveland Beach. We arrived right on time... but of course Tori
                insisted on applying sunscreen first. Ten minutes later, the two
                were finally walking along the beach. Adam stopped and told Tori
                how much he loved her and how excited he was to spend the rest
                of his life with her. With that, he got down on one knee and
                asked Tori to marry him. The rest is history…
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
